import { NavLink } from 'react-router-dom';
import { Building2, MapPin, Calendar, Hash, Layers, Globe, Printer, Plug, Receipt, SlidersHorizontal, Settings as SettingsIcon } from 'lucide-react';
import { ROUTES } from '@/routes/paths';

export function SettingsSubNav() {
  const tabs = [
    { label: 'Company Profile', path: ROUTES.settingsCompany || '/settings/company', icon: Building2 },
    { label: 'Locations & Facilities', path: ROUTES.settingsLocations || '/settings/locations', icon: MapPin },
    { label: 'Fiscal & Accounting', path: ROUTES.settingsFiscal || '/settings/fiscal', icon: Calendar },
    { label: 'Document Numbering', path: ROUTES.settingsNumbering || '/settings/numbering', icon: Hash },
    { label: 'Print Templates', path: ROUTES.settingsDocumentTemplates || '/settings/document-templates', icon: Printer },
    { label: 'Integrations', path: ROUTES.settingsIntegrations || '/settings/integrations', icon: Plug },
    { label: 'GST Registrations', path: ROUTES.settingsGstRegistrations || '/settings/gst-registrations', icon: Receipt },
    { label: 'CRM Setup', path: ROUTES.settingsCrmSetup || '/settings/crm-setup', icon: SlidersHorizontal },
    { label: 'Modules & Industry', path: ROUTES.settingsModules || '/settings/modules', icon: Layers },
    { label: 'Precision & Locale', path: ROUTES.settingsLocale || '/settings/locale', icon: Globe },
  ];

  return (
    <div className="bg-surface border-b border-outline px-6 pt-4 sticky top-0 z-20">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4 pb-4">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-xl bg-gradient-to-br from-primary to-primary-dim text-on-primary flex items-center justify-center shadow-surface-1 shrink-0">
            <SettingsIcon className="h-4 w-4" />
          </div>
          <div>
            <h1 className="text-xl font-bold tracking-tight text-on-surface">
              Enterprise Settings & SaaS Foundation
            </h1>
            <p className="text-xs text-on-surface-variant">
              Configure multi-tenant organization settings, facility branches, fiscal policies, and industry profiles.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto flex gap-6 overflow-x-auto text-xs font-semibold no-scrollbar">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                `pb-3 flex items-center gap-2 border-b-2 transition-colors whitespace-nowrap ${
                  isActive
                    ? 'border-primary text-primary font-bold'
                    : 'border-transparent text-on-surface-variant hover:text-on-surface'
                }`
              }
            >
              <Icon className="w-4 h-4" />
              {tab.label}
            </NavLink>
          );
        })}
      </div>
    </div>
  );
}

export default SettingsSubNav;
